import React from "react";

const selectedMedias = (props) => {
  const {
    selectSource,
    selectCh,
    filterType,
    deleteChecked,
    cancelAll,
  } = props;
  return (
    <div className="selected-media-container">
      <div className="selected-media">
        {selectSource.length > 0 ? (
          <div className="selected-media-header">
            <div className="popup-modal-buttonset">
              <button className="apply" onClick={() => cancelAll("selectSource")}>
                清除選取
              </button>
            </div>
          <div className="flex-block">
            <div className="title">
              {filterType === 1 ? "已選取的僅看媒體" : "已選取的排除媒體"}
            </div>
          </div>
          </div>
        ) : null}
        <section className="selected-media-list">
          {selectSource.map((source, index) => (
            <div className={ filterType === 1 ? "block selected" : "block  unselected"} key={index}>
              <i className="fa fa-close lowi-icon" onClick={() => deleteChecked(source)}></i>
              <div>{source}</div>
            </div>
          ))}
        </section>
      </div>

      <div className="selected-media">
        {selectCh.length > 0 ? (
          <div className="selected-media-header">
            <div className="popup-modal-buttonset">
              <button className="apply" onClick={() => cancelAll("selectCh")}>
                清除選取
              </button>
            </div>
          <div className="flex-block">
            <div className="title">
              {filterType === 1 ? "已選取的僅看子板" : "已選取的排除子板"}
            </div>
          </div>
          </div>
        ) : null}
        <section className="selected-media-list">
          {selectCh.map((ch, index) => (
            <div
              className={
                filterType === 1 ? "block selected" : "block  unselected"
              }
              key={index}
            >
              <i
                className="fa fa-close lowi-icon"
                onClick={() => deleteChecked(ch)}
              ></i>
              <div>
                {ch.name}({ch.source})
              </div>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default selectedMedias;



// WEBPACK FOOTER //
// ./src/components/popup/selectedMedias.js